// map i18n locales to API
import {
  MEETING_STATUS,
  VOTING_CRITERIA,
  VOTING_OPTIONS,
} from "@/constants/meeting";
import { PRIVILEGES } from "@/constants/privileges";
import { ROUTE_NAMES, ROUTES } from "@/constants/routeConstants";

export const API_LOCALE = [
  {
    value: "est",
    key: "et",
  },
  {
    value: "eng",
    key: "en",
  },
  {
    value: "rus",
    key: "ru",
  },
];

export const IBAN = {
  42: "Coop Pank aktsiaselts",
  96: "Luminor Bank AS",
  17: "Luminor Bank AS",
  77: "AS LHV Pank",
  10: "AS SEB Pank",
  75: "Bigbank AS",
  16: "Eesti Pank",
  22: "Swedbank AS",
  0o0: "AS TBB pank",
  12: "AS Citadele banka Eesti filiaal",
  51: "OP Corporate Bank plc Eesti filiaal",
};

export const LOCALE = ["est", "eng", "rus", "fin"];

export const FORM_ITEM_TYPE = {
  text: "text",
  date: "date",
  select: "select",
  hidden: "hidden",
  autocomplete: "autocomplete",
};

export const THEME_VARIANT = {
  primary: "primary",
  action: "action",
  info: "info",
  warning: "warning",
  danger: "danger",
  disabled: "disabled",
};

export const SIGN_STATUS = {
  completed: "completed",
  pending: "pending",
  failure: "failure",
  signed: "signed",
};

export const EFileRelationType = {
  DOCUMENT: "document",
  FORUM: "forum",
  NOTIFICATION_COOP: "notification_coop",
  NOTIFICATION_GLOBAL: "notification_global",
};

/* use as mixin to add const into component scope */
export default {
  created() {
    this.VOTING_CRITERIA = VOTING_CRITERIA;
    this.MEETING_STATUS = MEETING_STATUS;
    this.VOTING_OPTIONS = VOTING_OPTIONS;
    this.PRIVILEGES = PRIVILEGES;
    this.ROUTES = ROUTES;
    this.ROUTE_NAMES = ROUTE_NAMES;
    this.THEME_VARIANT = THEME_VARIANT;
    this.SIGN_STATUS = SIGN_STATUS;
  },
};
